import React, { createContext, ReactNode, useContext, useEffect } from "react";
import useLocalStorage from "../hooks/useLocalStorage";

import { authClient } from "../auth";
import { addToast } from "@heroui/react";
import { useRouter } from "next/router";
import { handleLogout } from "../../pages/_app";

type OpenBaasContextType = {
  uri: string;
  Error401?: ReactNode;
  setAccessToken: (token?: string) => void;
  setRefreshToken: (token?: string) => void;
  setIsLogin: (value?: boolean) => void;
  isLogin?: boolean;
  accessToken?: string;
  refreshToken?: string;
  logout: () => void;
};

const OpenBaasContext = createContext<OpenBaasContextType | undefined>(
  undefined
);

export function OpenBaasProvider({
  uri,
  children,
  Error401,
}: {
  uri: string;
  children: ReactNode;
  Error401?: ReactNode;
}) {
  const [isLogin, setIsLogin] = useLocalStorage<boolean | undefined>(
    "isLogin",
    undefined
  );
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = await authClient.getSession();
        if (session.data) {
          setIsLogin(true);
        } else {
          setIsLogin(false);
        }
      } catch (error) {
        setIsLogin(false);
      }
    };

    checkSession();
  }, []);
  const router = useRouter();
  return (
    <OpenBaasContext.Provider
      value={{
        uri,
        Error401,
        setAccessToken: () => {},
        setRefreshToken: () => {},
        setIsLogin,
        isLogin,
        accessToken: "",
        refreshToken: "",
        logout: async () => {
          await handleLogout();
          await authClient.signOut({
            fetchOptions: {
              onSuccess: () => {
                addToast({
                  title: "Sesión cerrada",
                  description: "Has cerrado sesión correctamente.",
                  color: "success",
                });
                router.push("/");
              },
            },
          });
          setIsLogin(false);
        },
      }}
    >
      {children}
    </OpenBaasContext.Provider>
  );
}

const useOpenBaas = () => {
  const context = useContext(OpenBaasContext);
  if (!context) {
    throw new Error("useOpenBaas must be used within OpenBaasProvider");
  }
  return context;
};

export { useOpenBaas };
export default OpenBaasProvider;
